"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _TravelRuleDepositModalComponent = _interopRequireDefault(require("./TravelRuleDepositModalComponent"));
var _depositActions = require("../../redux/actions/depositActions");
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// DEV-8959: Travel Rule deposit modal container - using modalDecorator pattern

var mapStateToProps = function mapStateToProps() {
  return {};
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    submitDepositTravelRuleInfo: function submitDepositTravelRuleInfo(data) {
      return dispatch((0, _depositActions.submitDepositTravelRuleInfo)(data));
    }
  };
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TravelRuleDepositModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.TRAVEL_RULE_DEPOSIT
})(container);